module.exports = __webpack_public_path__ + "static/recommendation-137758e25ee67a2ee287af8bbc6ff0db.mp4";